import { DEFAULT_API_CONFIG } from './apiConfig';

const { url, getHeaders } = DEFAULT_API_CONFIG;
const baseRoute = `${url}/account`;

export const getUsers = async () => {
  const url = `${baseRoute}/Users`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });
  return response.ok ? await response.json() : Promise.reject(response);
};

export const getAdminUsers = async () => {
  const url = `${baseRoute}/AdminUsers`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });
  return response.ok ? await response.json() : Promise.reject(response);
};

export const getMe = async () => {
  const url = `${baseRoute}/user`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });
  return response.ok ? await response.json() : Promise.reject(response);
};
export const getUserById = async id => {
  const url = `${baseRoute}/users/${id}`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });
  return response.ok ? await response.json() : Promise.reject(response);
};

export const getAccounts = async () => {
  const url = `${baseRoute}/Accounts`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });
  return response.ok ? await response.json() : Promise.reject(response);
}

export const createAccount = async account => {
  const url = `${baseRoute}/Account`;

  let headers = getHeaders();
  try {
    const response = await fetch(url, {
      method: 'POST',
      body: JSON.stringify(account),
      headers,
    });

    const data = await response.json();
    if (!response.ok) {
      throw {
        message: data || 'Failed to create account',
        status: response.status
      };
    }
    
    return data;
  } catch (error) {
    console.log('Error:', error);
    throw {
      message: error.message || 'Account name already exists.',
      status: 400
    };
  }
}

export const createAdminUser = async user => {
  user.role = 'ADMIN';
  user.userName = user.email;
  const url = `${baseRoute}/RegisterUser`;

  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'POST',
    body: JSON.stringify(user),
    headers,
  });

  return response.ok ? await response.json() : Promise.reject(response);
};

export const putAdminUser = async user => {
  user.role = 'ADMIN';
  const url = `${baseRoute}/UpdateUser`;

  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'PUT',
    body: JSON.stringify(user),
    headers,
  });

  return response.ok ? await response.json() : Promise.reject(response);
};

export const updatePassword = async user => {
  const url = `${baseRoute}/UpdatePassword`;
  let headers = getHeaders();

  const response = await fetch(url, {
    method: 'PUT',
    headers,
    body: JSON.stringify(user),
  });

  if (!response.ok) return Promise.reject(response);
  const text = await response.text();
  return text ? JSON.parse(text) : null;
};

export const updateMyAccount = async ({ email, phoneNumber }) => {
  const url = `${baseRoute}/Update-MyAccount`;
  let headers = getHeaders();

  const response = await fetch(url, {
    method: 'PUT',
    headers,
    body: JSON.stringify({ Email: email, PhoneNumber: phoneNumber }),
  });

  if (!response.ok) return Promise.reject(response);
  const text = await response.text();
  return text ? JSON.parse(text) : null;
};


export const forgotPassword = async username => {
  const url = `${baseRoute}/ForgotPassword`;
  let headers = getHeaders();
  let body = { UserName: username };
  const response = await fetch(url, {
    method: 'POST',
    headers,
    body: JSON.stringify(body),
  });

  return response.ok ? Promise.resolve() : Promise.reject(response);
};

export const resetPassword = async (username, password, resetToken) => {
  const url = `${baseRoute}/ResetPassword`;
  let headers = getHeaders();
  let body = { UserName: username, NewPassword: password, PasswordResetToken: resetToken };
  const response = await fetch(url, {
    method: 'POST',
    headers,
    body: JSON.stringify(body),
  });

  return response.ok ? Promise.resolve() : Promise.reject(response);
};

export const editUserRestrictions = async userRestrictions => {
  const url = `${baseRoute}/UserRestrictions/Edit`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'POST',
    body: JSON.stringify(userRestrictions),
    headers,
  });

  return response.ok ? await response.json() : Promise.reject(response);
};

export const getUserRestrictionsByUserId = async aspNetUserId => {
  const url = `${baseRoute}/UserRestrictions/${aspNetUserId}`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });

  return response.ok ? await response.json() : Promise.reject(response);
};

export const createUserRestrictions = async userRestrictions => {
  const url = `${baseRoute}/UserRestrictions/Create`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'POST',
    body: JSON.stringify(userRestrictions),
    headers,
  });

  return response.ok ? await response.json() : Promise.reject(response);
};
